import * as Constants from "../../../constants";
import METADATA from "../../../assets/data/search.meta.json";
import {ISearchState} from "../../../types/redux/search";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";

const useInsertDBFields = (): { insertField: Function } => {
  const searchState: ISearchState = useSelector<RootState, ISearchState>(state => state.search);

  const insertField = (str:string):{str:string, fs: string} =>{
    let fs: string = str;

    const terms: RegExpMatchArray | null = str.match(/(?:[^\s"]+|"[^"]*")+/g);
    let fieldSearches: string[] = [];
    if (terms) {
      fieldSearches = terms.filter((s:string)=>s.indexOf(':') !== -1);
    }

    if (fieldSearches.length > 0 ) {
      let fieldData: any;
      let fieldDataReverse: any;
      switch (searchState.db_set) {

        case Constants.BIBLIOGRAPHY:
          fieldData = METADATA.biblioAllFields;
          fieldDataReverse = METADATA.biblioAllFields_reverse;
          break;

        default:
          //Constants.DOCUMENTS:
          fieldData = METADATA.allFields;
          fieldDataReverse = METADATA.allFields_reverse;
          break;
      }

      fieldSearches.forEach(f => {
        let semicolonIndex: number = f.indexOf(":");

        let field: string = f.substring(0, semicolonIndex);
        const hasOpenParen: boolean = (field.substring(0, 1) === '(');
        if (hasOpenParen) {
          const numOfOpenParen:number = field.match(/^[(]*/)[0].length;
          field = field.substring(numOfOpenParen, field.length);
          f = f.substring(numOfOpenParen,f.length)
          semicolonIndex -= numOfOpenParen;
        }

        const hasCloseParen: boolean = (f.substring(f.length-1, f.length) === ')');
        if (hasCloseParen) {
          const numOfCloseParen:number = f.match(/[)]+$/)[0].length;
          f = f.substring(0,f.length - numOfCloseParen)
        }

        let data: string = fieldData[field];
        let dbField: string;
        if (data && data[1]) {
          str = str.replace(f, data[1] + f.substring(semicolonIndex, f.length)) ;
          dbField = hasOpenParen ? '<span class="paren">'+ data[1] + '</span>' : '<span>' + data[1] + '</span>'
          fs = fs.replace(f, dbField  + f.substring(semicolonIndex, f.length) );
        } else {
          data = fieldDataReverse[field];
          if (data) {
            /* full field name entered */
            dbField = hasOpenParen ? '<span class="paren">'+ field + '</span>:' : '<span>' + field + '</span>'
            fs = fs.replace(f, dbField + f.substring(semicolonIndex, f.length) );
          }
        }
      })
    }

    return {
      str,
      fs
    }
  }

  return {
    insertField
  }
};

export default useInsertDBFields;
